import { ExcludeItem } from "@app/componentlib/common/types/CVTypes";

export const profileExclusionParambuilder = (exclusions: ExcludeItem[]) => {
  //This takes profile exclusions to CV Preview Image and makes it into search params
  let search = "";
  exclusions.forEach((e: ExcludeItem, idx, array) => {
    const findId = e.id || e.Id || undefined;
    if (!findId) {
      //If no id is found, return empty string.
      return "";
    }
    const id = findId.toString();
    //Build param as endpoint demands i.e. Exclusions.ItemTypes
    const str2 = new URLSearchParams({
      [`Exclusions.${e.type}`]: id,
    }).toString();
    if (idx === array.length - 1) {
      //If last in array, dont add '&'.
      search = search.concat(str2);
    } else {
      search = search.concat(str2 + "&");
    }
  });
  return search;
};
